export function needsSimpleTemplate(route) {
  let result = false;

  if (
    // Fullscreen system render
    route.includes('/system-view') ||
    // Fullscreen quote render
    route.includes('/quote-view')
  ) {
    result = true;
  }

  return result;
}



// WEBPACK FOOTER //
// ./js/utils/route.js